
import BScroll from "@better-scroll/core"
import { formatImgUrl } from "../../utils/utils"
import lazyImg from "@/components/cms/lazyImg.vue"
import ObserverHOC from "@/components/ObserverHOC"
import { trackViewImageModule, trackSelectImageModule } from "@/utils/track"

export default {
  name: "CmsVerticalBannerView",
  components: {
    lazyImg,
    ObserverHOC
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      scroll: null,
      curShowIndex: 0, // 当前显示的图索引
      showArrowLeft: false,
      showArrowRight: true,
      groupTitle: "", // 组标题
      listData: [], // 列表数据
      titleColor: "#000" // 组标题颜色
    }
  },
  computed: {
    bannerWidth() {
      // 单个宽度目前为150px ,一行显示7.5个
      const width = this.listData.length * 1.5
      const gapWidth = (this.listData.length - 1) * 0.16
      const { heightWideRatio = 0 } = this.configData.groupFeature || {}
      const height = heightWideRatio ? this.getBannerHeight(heightWideRatio) : 180
      return {
        width: width + gapWidth + "rem",
        height: height / 100 + "rem" // height需要除以 100
      }
    }
  },
  watch: {
    configData: {
      handler(newVal = {}) {
        this.groupTitle = newVal.groupFeature.showTitle ? newVal.groupFeature.titleNew : ""
        this.listData = newVal.subConfigList || []
        this.titleColor = newVal.groupFeature.titleColor || "#000"
        if (this.listData.length <= 7) {
          this.showArrowRight = false
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.verticalBannerRef, {
        scrollX: true,
        click: true,
        probeType: 3,
        bounce: false,
        eventPassthrough: "vertical"
      })
      this.scroll.on("scroll", this.onScroll)
    })
  },
  methods: {
    formatImgUrl,
    getBannerHeight(ratio) {
      return Math.round(150 * ratio)
    },
    formatLinkTo(item) {
      return item.resource
    },
    handleArrowClick(type) {
      // 单个宽度目前为150px ,一行显示8.5个,间隔16px
      const curLen = 8 * 166 - 16
      this.curShowIndex = type === "left" ? this.curShowIndex - 1 : this.curShowIndex + 1
      if (this.curShowIndex < 0) {
        this.curShowIndex = 0
      }
      let num = curLen * this.curShowIndex
      if (num > Math.abs(this.scroll.maxScrollX)) {
        num = Math.abs(this.scroll.maxScrollX)
      }
      const move = -num
      this.scroll.scrollTo(move, 0, 300)
    },
    onScroll(pos) {
      // 判断结束,完整可视商品目前为8个
      const length = Math.ceil(Math.abs(pos.x / 166))
      if (pos.x == this.scroll.maxScrollX || (length && length >= this.listData.length - 8)) {
        this.showArrowRight = false
      } else {
        this.showArrowRight = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
      this.$bus.$emit("handleCardsScroll")
    },
    // 曝光
    handleVisibility(target, index) {
      trackViewImageModule(this.listData[index], index)
    },
    // 点击
    handleImageClick(item) {
      const params = {
        module_ID: String(item.parentId || ""),
        creative_slot: String(item.positionId || ""),
        creative_name: item.layoutName || ""
      }
      sessionStorage.setItem("seveneleven_TRACK_IMAGE_MODULE", JSON.stringify(params))
      trackSelectImageModule(item)
    }
  }
}
